import type { JSX } from 'react';
import { useEffect, useRef } from 'react';
import type { Turn } from '../conversation';
import { Markdown } from './Markdown';
import { SurfaceList } from '../surfaces/SurfaceRenderer';
import { useT } from '../i18n/useT';

export function Thread({ turns, busy }: { turns: Turn[]; busy: boolean }): JSX.Element {
  const t = useT();
  const endRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    endRef.current?.scrollIntoView?.({ block: 'end', behavior: 'smooth' });
  }, [turns.length, busy]);
  return (
    <main className="thread" aria-live="polite">
      {turns.length === 0 ? (
        <div className="empty-state">
          <h2>{t('productName')}</h2>
          <p className="muted">{t('composerPlaceholder')}</p>
        </div>
      ) : null}
      {turns.map((turn) => (
        <article key={turn.id} className={`turn turn-${turn.role}${turn.status ? ` turn-${turn.status}` : ''}`} data-testid={`turn-${turn.role}`}>
          <div className="bubble">
            {turn.role === 'user' ? (
              <p>
                {turn.inputMode === 'voice' ? (
                  <span className="badge" title="Spoken command">
                    🎤
                  </span>
                ) : null}
                {turn.text}
              </p>
            ) : (
              <Markdown text={turn.text} />
            )}
          </div>
          {turn.surfaces.length > 0 ? <SurfaceList surfaces={turn.surfaces} /> : null}
        </article>
      ))}
      {busy ? (
        <article className="turn turn-assistant turn-pending">
          <div className="bubble muted">{t('thinking')}</div>
        </article>
      ) : null}
      <div ref={endRef} />
    </main>
  );
}
